<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="4"
      y="5"
      width="16"
      height="14"
      rx="1"
      :stroke="color"
      stroke-width="1.5"
    />
    <path d="M4 9H20" :stroke="color" stroke-width="1.5" />
    <path d="M4 15H20" :stroke="color" stroke-width="1.5" />
    <path d="M12 9V15" :stroke="color" stroke-width="1.5" />
    <path
      d="M12 5V4"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M10 3H14"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
